<script lang="ts">
	import Icon from "./Icon.svelte";
	import success from "../../../core/assets/icons/check.svg?raw";
	import error from "../../../core/assets/icons/error.svg?raw";
	import info from "../../../core/assets/icons/info.svg?raw";
	import warning from "../../../core/assets/icons/warning.svg?raw";

	type MessageVariant = "success" | "error" | "info" | "warning";

	let messageClass = "";
	export { messageClass as class };
	export let variant: MessageVariant = "error";

	const messageVariants: Record<MessageVariant, string> = {
		success: "bg-lttertiary",
		error: "bg-ltprimary-100 border-ltprimary-300 text-ltprimary-300",
		info: "bg-ltprimary-100",
		warning: "bg-orange-100",
	};

	const messageIconVariants: Record<MessageVariant, string> = {
		success: "text-lttertiary h-[.8rem] [&>svg]:mt-[.1rem]",
		error: "text-ltprimary-300 h-4 [&>svg]:mt-[.15rem]",
		info: "text-ltsecondary-300 h-4 [&>svg]:mt-[.15rem]",
		warning: "text-orange-400 h-[.8rem] [&>svg]:mt-[.1rem]",
	};

	const iconMap: Record<MessageVariant, string> = {
		success,
		error,
		info,
		warning,
	};
</script>

<div
	class="mt-1 flex items-baseline gap-2 text-wrap rounded-lg p-4 text-xs/[1.1] font-semibold text-black {messageVariants[
		variant
	]} {messageClass}"
>
	<Icon icon={iconMap[variant]} class={messageIconVariants[variant]} />
	<slot />
</div>
